import React, { useContext } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { UserContext } from "../UserContext";
import { motion } from "framer-motion";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi2";

export const CustomConfirmDialog = ({
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  const { darkTheme } = useContext(UserContext);
  return (
    <motion.div
      className={`w-72 md:w-80 m-2 px-6 py-6 rounded-2xl shadow-2xl border ${
        darkTheme ? "bg-DarkGray border-White/10" : "bg-White border-Border"
      }`}
      initial={{ opacity: 0, y: 15, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 15, scale: 0.96 }}
      transition={{ type: "spring", stiffness: 300, damping: 26 }}
    >
      <div className={`flex items-center flex-col text-center`}>
        <div
          className={`flex items-center justify-center w-11 h-11 rounded-full mb-3 ${
            darkTheme ? "bg-cfBlue/20 text-blue-100" : "bg-cfBlue/10 text-cfBlue"
          }`}
        >
          <HiOutlineQuestionMarkCircle className="w-6 h-6" />
        </div>
        <h3
          className={`custom-title text-base font-semibold ${
            darkTheme ? "text-White" : "text-Text"
          }`}
        >
          {title}
        </h3>
        <p
          className={`mt-1.5 text-[13.5px] leading-relaxed ${
            darkTheme ? "text-[#c3c3c3]" : "text-[#5b5b5b]"
          }`}
        >
          {message}
        </p>
        <div className={`flex items-center gap-3 mt-6 w-full`}>
          <button
            onClick={onConfirm}
            className={`flex-1 py-2 rounded-full text-sm font-semibold text-White transition-all active:scale-[0.97] shadow-sm ${
              darkTheme
                ? "bg-cfBlue hover:bg-[#0c3fb0]"
                : "bg-cfBlue hover:bg-[#083ec2]"
            }`}
          >
            Yes
          </button>
          <button
            onClick={onCancel}
            className={`flex-1 py-2 rounded-full text-sm font-medium transition-all active:scale-[0.97] ${
              darkTheme
                ? "bg-transparent border border-White/15 text-White hover:bg-White/5"
                : "bg-transparent border border-Border text-Text hover:bg-Bg"
            }`}
          >
            No
          </button>
        </div>
      </div>
    </motion.div>
  );
};

// const showDialog = () => {
//   confirmAlert({
//     customUI: ({ onClose }) => {
//       return (
//         <CustomConfirmDialog
//           title='Are you sure?'
//           message='You want to delete this file?'
//           onConfirm={() => {
//             onClose();
//             // Handle confirm action
//           }}
//           onCancel={onClose}
//         />
//       );
//     },
//   });
// };

// const App = () => {
//   return (
//     <div>
//       <button onClick={showDialog}>Show Confirm Dialog</button>
//     </div>
//   );
// };
